/** @see https://developer.briqpay.com/docs/3.0.0/api/briqpay-api */
export const BRIQPAY_API_URL = process.env.BRIQPAY_API_URL ?? ''
/**
 * The Basic-auth username. Briqpay calls it the "Mid" in the portal (API keys page) —
 * there is no separate username field.
 */
export const BRIQPAY_MID = process.env.BRIQPAY_MID ?? ''
export const BRIQPAY_SECRET = process.env.BRIQPAY_SECRET ?? ''
// No BRIQPAY_WEBHOOK_SECRET: we do not verify `x-briq-signature`. The webhook body is
// never trusted — every path re-reads the session from Briqpay — so a forged call cannot
// provision an unpaid order. See `provisionOrderBriqpayProvider` for the full reasoning and what
// would have to change to add verification.

/**
 * Every v3 call authenticates with `Basic base64(mid:secret)` — no token exchange and no
 * bearer refresh. Briqpay also offers short-lived scoped secrets via `POST /v3/auth`, but
 * every call we make is server-side, so a scoped secret buys nothing and costs a
 * round-trip.
 *
 * @see https://developer.briqpay.com/docs/3.0.0/guides/guides/additional_guides/authenticate/
 */
export const BRIQPAY_AUTH_HEADERS = {
  Authorization: `Basic ${Buffer.from(`${BRIQPAY_MID}:${BRIQPAY_SECRET}`).toString('base64')}`
}
